// extracted by mini-css-extract-plugin
module.exports = {"expander":"Expander_expander__2MVSO","expanderText":"Expander_expanderText__2xrRa","expanderIcon":"Expander_expanderIcon__2hFW7","rotateIcon":"Expander_rotateIcon__2-Vne"};